module.exports = {"title":"Jan Lehnardt","talk":"undefined","path":"/speakers/jan-lehnardt","type":"speaker","slug":"jan-lehnardt","twitter":"janl","github":"janl","website":"http://writing.jan.io/","companyWebsite":"https://neighbourhood.ie/","company":"Neighbourhoodie Software","body":"<p>Co-curator for JSConf EU, the project lead of Apache CouchDB and co-inventor of Hoodie. He lives in Berlin and likes to change the world.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/jan-lehnardt.md
 ** module id = 538
 ** module chunks = 0
 **/